import React from 'react';
import ReactDOM from 'react-dom';
import Layout from './layout/';
import '@Container/common/client/commoncss/resetMobile.css';

/* eslint-disable no-undef */
ReactDOM.hydrate(<Layout content={allData} />, document.getElementById('root'));
/* eslint-enable no-undef */
